<template>
  <BootstrapVueTable
    :title="title"
    :subtitle="subtitle"
    :items="table_data"
    :fields="table_fields" />
</template>

<script>
import axios from 'axios'
import errorRoutingMixin from '@/mixins/errorRoutingMixin'
import data_formats from '@/utils/data_formats'
import BootstrapVueTable from '@/components/BootstrapVueTable'

export default {
  name: 'assigned_rates',
  components: {BootstrapVueTable},
  mixins: [errorRoutingMixin],
  props: ['reference_entity', 'reference_year', 'reference_month'],
  data () {
    return {
      title: "Taux d'affectation",
      subtitle: "Cette table permet la vérification des taux d'affectation des collaborateurs en fonction du type de chaque projet.",
      raw_data: [],
      table_data: [],
      table_fields: [],
    }
  },
  watch: {
    all_props () {
      this.load_server_data()
    }
  },
  created () {
    this.load_server_data()
  },
  computed: {
    all_props () {
      return [
        this.reference_entity,
        this.reference_year,
        this.reference_month  
      ]
    },
  },
  methods: {
    load_server_data () {
      if (! this.reference_entity) return  // If user is not yet authenticated. do nothing
      let url = 'webapi/assigned-rates?entity=' + this.reference_entity + '&year=' + this.reference_year + '&month=' + this.reference_month 
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
        .then(response => this.raw_data = response.data)
        .then(_ => this.build_table_data())
        .catch(error => {
          console.log(error)
          this.$router.push(this.routeOnError(error.response.status))
        })
    },

    build_table_data() {
      let raw_data = this.raw_data
      raw_data.AFFECTSTARTDATE = raw_data.AFFECTSTARTDATE.map(s => new Date(s))
      raw_data.AFFECTENDDATE = raw_data.AFFECTENDDATE.map(s => new Date(s))
      this.table_data = data_formats.col_to_row_format(raw_data)

      let sortable = {sortable: true}
      let number_format = {formatter: data_formats.number_format_frch_two_decimals, class: 'text-right', ...sortable}
      let date_format = {formatter: data_formats.date_format_frch_short, class: 'text-left', ...sortable}
      this.table_fields = [{key: 'COLLABORATORNAME', label: 'Nom', ...sortable},
                           {key: 'COLLABORATORFIRSTNAME', label: 'Prénom', ...sortable},
                           {key: 'IDPROJECTHESSO', label: 'No. projet', ...sortable},
                           {key: 'PROJECTACRONYM', label: 'Acronyme'},
                           {key: 'PROJECTCATSHORT', label: 'Type', ...sortable},
                           {key: 'AFFECTSTARTDATE', label: 'Début affectation', ...date_format},
                           {key: 'AFFECTENDDATE', label: 'Fin affectation', ...date_format},
                           {key: 'AFFECTRATE', label: 'Taux', ...number_format}
      ]
    },
  }
}
</script>